import { cn } from '@workingclock/ui';

/**
 * Compact clock/timer mark (PRODUCT.md: "clock/timer + progress, suited to a
 * compact mark"). A plain circle dial in Ink with a single Chronometer Gold
 * hand, the one accent on the whole mark — no gradients, no second color.
 */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cn('h-6 w-6', className)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.75" className="text-ink" />
      <path d="M12 12 L12 6.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" className="text-ink" />
      <path d="M12 12 L16 14" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" className="text-gold" />
    </svg>
  );
}
